import React,{useState,useEffect} from 'react'
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Button, Input, Table, Container, CardTitle, CardFooter} from "reactstrap";
import {fetchNiceReport} from 'network/ApiAxiosTickets'
import Chart from 'chart.js';
import { Line, Bar, Doughnut } from "react-chartjs-2";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import Header from 'components/Headers/Header';

function NiceReport() {
    const [startDate, setStartDate] = useState(new Date(new Date().toISOString().split('T')[0] + 'T00:00:00.000Z'));
    const [endDate, setEndDate] = useState(new Date(new Date().toISOString().split('T')[0] + 'T23:59:59.000Z'));
    const [totalsByMoney, setTotalsByMoney] = useState(null);
    const [totalsByTickets, setTotalsByTickets] = useState(null);
    const [dayTotals, setDayTotals] = useState(null);
    const [competitionTotals, setCompetitionTotals] = useState(null);
    const [moneyTickets, setmoneyTickets] = useState(true);

    useEffect(() => {
      getReport()
    }, []);

    const role = JSON.parse(localStorage.getItem("user")).role

    const onDateChange = (dates) => {
        const [start, end] = dates;
        console.log(start.toISOString().split('T')[0] + '00:00:00.000Z') 
        setStartDate(start);
        setEndDate(end);
      };

      const makeDataDayTotals = (data)=>{
        return {
          labels: Object.keys(data),
          datasets: [
            {
              label: "Sales",
              data: Object.values(data),
              maxBarThickness: 10,
            },
          ],
        }
      }

      const makeDataSellerTotals = (data,type)=>{
        return {
          labels: data.map((sellerItem) => Object.keys(sellerItem)[0]),
          datasets: [
            {
              label: "Sales",
              data: data.map((sellerItem) => Object.values(sellerItem)[0][type] ),
              maxBarThickness: 10,
            },
          ],
        }
      }

      const options= {
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (something) {
                  if (!(something % 10)) {
                    //return '$' + something + 'k'
                    return something;
                  }
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function (item, data) {
              var label = data.datasets[item.datasetIndex].label || "";
              var yLabel = item.yLabel;
              var content = "";
              if (data.datasets.length > 1) {
                content += label;
              }
              content += yLabel;
              return content;
            },
          },
        },
      }

      const getReport = async()=>{
        if(!startDate || !endDate) return
        const resp = await fetchNiceReport(startDate,endDate)
        if(resp.data.success){
          let totalsArray = []

          Object.keys(resp.data.totals).forEach(key => {
            totalsArray.push({[key]: resp.data.totals[key]});
          });

          let competitionArray = []

          Object.keys(resp.data.competitionTotals).forEach(key => {
            competitionArray.push({[key]: resp.data.competitionTotals[key]});
          });
          console.log(competitionArray)

          setTotalsByMoney(

            totalsArray.sort((a,b)=>{
              return b[Object.keys(b)[0]].money - a[Object.keys(a)[0]].money
            }))
          setTotalsByTickets(
            totalsArray.sort((a,b)=>{
              return b[Object.keys(b)[0]].tickets - a[Object.keys(a)[0]].tickets
            }))
console.log(resp.data.dayTotals)
          setDayTotals(resp.data.dayTotals)
          setCompetitionTotals(
            competitionArray.sort((a,b)=>{
              return b[Object.keys(b)[0]] - a[Object.keys(a)[0]]
            })
            )
        }
      }

      const toggleMoney =()=>setmoneyTickets(!moneyTickets)

  return (
    <>
    {role == 'admin' && <Header/>}
    <Container>
      <Row>
        <DatePicker onChange={onDateChange} startDate={startDate} endDate={endDate} selectsRange withPortal placeholderText="Select a date" calendarStartDay={1} className='ml-2 mt-3'/>
        <Button className='ml-2' onClick={getReport} > Go</Button>
      </Row>
        {dayTotals && <Bar data={makeDataDayTotals(dayTotals)} options={options} />}
        {dayTotals && console.log(makeDataDayTotals(dayTotals))}
      
          <Card className='mt-4'>
            <CardHeader>
              <Row>
                <Col md='10'>
                  <CardTitle>Sales By Seller</CardTitle>
                </Col>
                <Col md='2'>
                  <Button className={moneyTickets ? 'rounded-circle float-end' : 'rounded-circle float-end btn-info'} onClick={toggleMoney} >Q</Button>
                  <Button className={!moneyTickets ? 'rounded-circle float-end' : 'rounded-circle float-end btn-info'} onClick={toggleMoney} >$</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody style={{height:'200px', overflow:'auto'}}>
                {totalsByMoney ? moneyTickets ?
                totalsByMoney.map((sellerItem)=>{
                  return <>
                          <Row key={Object.keys(sellerItem)[0]}>
                            <Col md='8'>
                              <h3>{Object.keys(sellerItem)[0]}</h3>
                            </Col>
                            <Col md='4'>
                              <h3 className='ml-4'>{sellerItem[Object.keys(sellerItem)[0]].money}</h3>
                            </Col>
                          </Row>
                        </>
                }) :
                totalsByTickets.map((sellerItem)=>{
                  return <>
                          <Row key={Object.keys(sellerItem)[0]}>
                            <Col md='8'>
                              <h3>{Object.keys(sellerItem)[0]} </h3>
                            </Col>
                            <Col md='4'>
                              <h3>{sellerItem[Object.keys(sellerItem)[0]].tickets}</h3>
                            </Col>
                          </Row>
                        </>
                }) :
                null
                }
                
            </CardBody>
            <CardFooter>
                {totalsByMoney && 
                <Bar data={
                  moneyTickets ?
                    makeDataSellerTotals(totalsByMoney.slice(0, 5),'money') :
                    makeDataSellerTotals(totalsByTickets.slice(0, 5),'tickets') 
                } options={options} />}

            </CardFooter>
          </Card>

        <Card className='mb-4 mt-4'>
            <CardHeader>
              <CardTitle>Competition</CardTitle>
            </CardHeader>
            <CardBody style={{height:'200px', overflow:'auto'}}>
              {
                competitionTotals && competitionTotals.map((sellerItem)=>{
                  return <>
                          <Row key={Object.keys(sellerItem)[0]}>
                            <Col md='8'>
                              <h3>{Object.keys(sellerItem)[0]} </h3>
                            </Col>
                            <Col md='4'>
                              <h3>{Object.values(sellerItem)[0]}</h3>
                            </Col>
                          </Row>
                        </>
                })
              }
            </CardBody>
          </Card>

    </Container>
    </>
  )
}

export default NiceReport